const itemComparitionTable = [
  { ids: [273, 274], name: '総合' },
  { ids: [275, 276], name: 'どんなことが起こる？' },
  { ids: [277, 278], name: '結婚' },
  { ids: [279, 280], name: '家族' },
  { ids: [281, 282], name: '仕事' },
  { ids: [283, 284], name: 'お金' },
  { ids: [285, 286], name: '人間関係' },
  { ids: [287, 288], name: '運気の流れ' },
  { ids: [289, 290], name: '上半期の月ごとのアドバイス' },
  { ids: [291, 292], name: '幸運日カレンダー' },
  { ids: [293, 294], name: '相性' },
  { ids: [295, 296], name: '総合' },
  { ids: [297, 298], name: '運気セット' },
  { ids: [299, 300], name: '恋愛セット' },
  { ids: [301, 302], name: '人間関係セット' },
  { ids: [303, 304], name: '全メニューセット' }
]

export default {
  itemComparitionTable: itemComparitionTable
}






















// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/YearLuck/y2020/constants/items.js